// extracted by mini-css-extract-plugin
export default {"homepage4":"Homepage4_homepage4__HzN+G","box":"Homepage4_box__qfk5Q"};